<app-user-access-block
  [sectionName]="sectionName"
  [entityName]="entityName"
  [entityField]="entityField"
  [permissionSectionEntities]="userFacade.permissionSectionEntities$ | async"
>
  <ng-content></ng-content>
</app-user-access-block>
